import { atom } from 'jotai';

import type { SessionUser } from '@/types/session/SessionUser';

/**
 * What the module knows before a host names the reader: nobody, and no rights. Exported so a test
 * can put the shared store back to it -- this atom lives in jotai's default store, so a value one
 * mount writes is still there for the next.
 */
export const DEFAULT_SESSION_USER: SessionUser = {
    userId: '',
    firstName: '',
    lastName: '',
    email: '',
    companyId: '',
    isAdminUser: false,
    isAmelioAdmin: false,
    surveyLanguages: [],
};

export const userInstanceAtom = atom<SessionUser>(DEFAULT_SESSION_USER);
